import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiCheckbox from '@material-ui/core/Checkbox';

import {
  secondary300,
  secondary200,
  blueberry, frenchPink,
  caribbeanGreen, mellowApricot,
} from '../../../src/themes/colors';

const styles = theme => ({
  root: {
    color: secondary300,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  colorBlue: {
    color: blueberry,
    '&:hover': {
      color: blueberry,
    },
  },
  colorPink: {
    color: frenchPink,
    '&:hover': {
      color: frenchPink,
    },
  },
  colorGreen: {
    color: caribbeanGreen,
    '&:hover': {
      color: caribbeanGreen,
    },
  },
  colorYellow: {
    color: mellowApricot,
    '&:hover': {
      color: mellowApricot,
    },
  },
  disabled: {
    color: secondary200,
  },
});

const Checkbox = (props) => {
  const { classes } = props;
  return (
    <MuiCheckbox
      classes={{
        root: classes.root,
        disabled: classes.disabled,
        colorBlue: classes.colorBlue,
        colorPink: classes.colorPink,
        colorGreen: classes.colorGreen,
        colorYellow: classes.colorYellow,
      }}
      disableRipple
      {...props}
    >
      {props.children}
    </MuiCheckbox>
  );
};

export default withStyles(styles)(Checkbox);
